import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { PurchasePopup } from './components/Shared';
// Lazy-load every section below the fold so the initial JS bundle stays tiny
// and the hero paints fast. Each section streams in as the user scrolls.
const Problem = lazy(() => import('./components/Problem').then(m => ({
  default: m.Problem
})));
const Product = lazy(() => import('./components/Product').then(m => ({
  default: m.Product
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Social = lazy(() => import('./components/Social').then(m => ({
  default: m.Social
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FB_PIXEL_ID = '934687369580178';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}
const SectionFallback = () => <div className="min-h-[50vh]" aria-hidden="true" data-id="element-0" />;
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Skip pixel inside the Magic Patterns preview iframe to avoid CORS / sandbox errors.
    try {
      if (window.self !== window.top) return;
    } catch {
      return;
    }
    // Defer pixel until after first paint so it never blocks LCP.
    const loadPixel = () => {
      try {
        if (window.fbq) {
          window.fbq('track', 'PageView');
          return;
        }
        /* eslint-disable */
        ;
        (function (f: any, b: any, e: any, v: any) {
          let n: any, t: any, s: any;
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          t.onerror = function () {};
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        /* eslint-enable */
        window.fbq?.('init', FB_PIXEL_ID);
        window.fbq?.('track', 'PageView');
      } catch {
        /* fail silently */
      }
    };
    const idle = (window as unknown as {
      requestIdleCallback?: (cb: () => void) => number;
    }).requestIdleCallback;
    if (idle) {
      idle(loadPixel);
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-terracotta/30" data-id="element-1">
      <noscript data-id="element-2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" />
      </noscript>

      <Hero data-id="element-4" />

      <Suspense fallback={<SectionFallback data-id="element-6" />} data-id="element-5">
        <Problem data-id="element-7" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-9" />} data-id="element-8">
        <Product data-id="element-10" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-12" />} data-id="element-11">
        <Bonuses data-id="element-13" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-15" />} data-id="element-14">
        <Pricing data-id="element-16" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-18" />} data-id="element-17">
        <Social data-id="element-19" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-21" />} data-id="element-20">
        <FAQ data-id="element-22" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-24" />} data-id="element-23">
        <Footer data-id="element-25" />
      </Suspense>

      <PurchasePopup data-id="element-26" />
    </div>;
}